export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'

/** Replace `{{line}}` (and legacy `{line}`) placeholders in CMS aria-label templates. */
export const formatLineAriaLabel = (template: string | null | undefined, lineName: string) =>
  (template || "").replace(/\{\{line\}\}|\{line\}/g, lineName)

export const configureSVGAccessibility = (svg, altText) => {
  svg.setAttribute("role", "img")
  if (altText) {
    svg.setAttribute("aria-label", altText)
  } else {
    svg.setAttribute("aria-hidden", "true")
  }
}

export const setInert = (element: HTMLElement | null, inert: boolean) => {
  if (!element) {
    return
  }
  if (inert) {
    element.setAttribute("inert", "")
    element.setAttribute("aria-hidden", "true")
    return
  }
  element.removeAttribute("inert")
  element.removeAttribute("aria-hidden")
}

export const isVisibleFocusable = (element: HTMLElement) => {
  if (element.hasAttribute("disabled") || element.getAttribute("aria-hidden") === "true") {
    return false
  }

  let node: HTMLElement | null = element
  while (node) {
    if (node.getAttribute("aria-hidden") === "true" || node.hasAttribute("inert")) {
      return false
    }
    const style = window.getComputedStyle(node)
    if (style.visibility === "hidden" || style.display === "none") {
      return false
    }
    node = node.parentElement
  }

  return element.getClientRects().length > 0
}

export const getVisibleFocusableElements = (root: ParentNode) =>
  Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(isVisibleFocusable)

/** Move focus within `elements`. If focus is outside the list, land on the first/last item. */
export const focusInCycle = (elements: HTMLElement[], active: Element | null, reverse: boolean) => {
  if (elements.length === 0) {
    return
  }

  const currentIndex = elements.findIndex(el => el === active || (!!active && el.contains(active)))
  if (currentIndex === -1) {
    ;(reverse ? elements[elements.length - 1] : elements[0]).focus()
    return
  }

  const nextIndex = (currentIndex + (reverse ? -1 : 1) + elements.length) % elements.length
  elements[nextIndex].focus()
}
